/**
 RC4 encryption decryption library
 @class RC4
 @constructor
 @return {Object} instantiated RC4
 **/

export class RC4 {
    m_passkey: any;
    
    constructor(i_passkey) {
        this.m_passkey = i_passkey;
    };

    /**
     Arcfour_algorithm
    **/
    _arcfour_crypt(i_data, i_key){
        let STATE_LENGTH = 256;
        let i, i1, i2, x, y, temp;
        let secretKey = new Array(STATE_LENGTH);
        let keyLen = i_key.length;
        let dataLen = i_data.length;
        let output = new Array(dataLen);

        i1 = 0;
        i2 = 0;
        x = 0;
        y = 0;
        for (i = 0; i < STATE_LENGTH; i++)
            secretKey[i] = i;


        for (i = 0; i < STATE_LENGTH; i++) {
            i2 = ((i_key.charCodeAt(i1) & 255) + secretKey[i] + i2) & 255;
            // swap
            temp = secretKey[i];
            secretKey[i] = secretKey[i2];
            secretKey[i2] = temp;
            i1 = (i1 + 1) % keyLen;
        }

        for (i = 0; i < dataLen; i++) {
            x = (x + 1) & 255;
            y = (secretKey[x] + y) & 255;
            // swap
            temp = secretKey[x];
            secretKey[x] = secretKey[y];
            secretKey[y] = temp;
            // xor
            output[i] = i_data.charCodeAt(i) ^ secretKey[(secretKey[x] + secretKey[y]) & 255];
        }
        return this._arcfour_byte_string(output);
    }

    /**
     Convert byte array into string.
    **/
    _arcfour_byte_string(i_input) {
        let output = "";
        for (let i = 0; i < i_input.length; i++) {
            output += String.fromCharCode(i_input[i]);
        }
        return output;
    }

    /**
     Get the hex representation of an array of bytes
    **/
    _arcfour_hex_encode(i_input) {
        let hex_digits = "0123456789abcdef";
        let output = "";
        for (let i = 0; i < i_input.length; i++) {
            output += hex_digits.charAt((i_input.charCodeAt(i) >>> 4) & 15);
            output += hex_digits.charAt(i_input.charCodeAt(i) & 15);
        }
        return output;
    }

    /**
     Decode hex string
    **/
    _arcfour_hex_decode(i_input) {
        let left, right, index;
        let output = new Array(i_input.length / 2);
        for (let i = 0; i < i_input.length; i += 2) {
            left = i_input.charCodeAt(i);
            right = i_input.charCodeAt(i + 1);
            index = i / 2;
            if (left < 97)  // left < 'a'
                output[index] = ((left - 48) << 4);  // left - '0'
            else
                output[index] = ((left - 97 + 10) << 4);
            if (right < 97)
                output[index] += (right - 48);
            else
                output[index] += (right - 97 + 10);
        }
        return this._arcfour_byte_string(output);
    }

    /**
     Generate a key in case we need a new one
    **/
    _genKey() {
        let key = new Array();
        let i = 0;
        let n;
        while (i < 16) {
            n = Math.ceil(Math.random() * 255);
            key[i] = n;
            i++;
        }
        return this._arcfour_hex_encode(this._arcfour_byte_string(key));
    }

    /**
     Execute an encryption using pass
     return encrypted dtaa
    **/
    doEncrypt(i_plaintext) {
        if (i_plaintext.length > 0) {
            return this._arcfour_hex_encode(this._arcfour_crypt(i_plaintext, this._arcfour_hex_decode(this.m_passkey)));
        }
    }

    /**
     Execute an decryption using pass on i_value
     method doDecrypt
    **/
    doDecrypt(i_value) {
        let ciphertext = this._arcfour_hex_decode(i_value);
        if (ciphertext.length > 0) {
            return this._arcfour_crypt(ciphertext, this._arcfour_hex_decode(this.m_passkey));
        }
    }
}
